<template>
  <div class="log-wrapper">
    <p class="title">登录日志</p>
    <div class="log-box">
      <div
        class="log-item"
        v-for="(item,index) in logList"
        :key="index"
        v-show="compareDate(new Date(item.date_logined))"
      >
        <div class="first-line">
          <i class="iconfont iconkzt_dlrz1"></i>
          <span class="city-name">{{item.location.city}}</span>
          <span class="ip">{{item.ip}}</span>
        </div>
        <div class="time">{{formatDate(new Date(item.date_logined))}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserLog } from '@/services/interface'
import { formatDate } from '@/util/common'
export default {
  data () {
    return {
      logList: []
    }
  },
  methods: {
    /**
     * 获取登录日志
     */
    async getUserLog () {
      const res = await getUserLog().then((res) => {
        return res
      })
      this.logList = res.data.data.slice(0, 7)
    },

    /**
     * 比较时间，进行隐藏
     * @param date: new Date()
     */
    compareDate (date) {
      return date.getTime() > new Date('2020-07-01').getTime()
    },

    /**
     * 时间格式化方法
     */
    formatDate: formatDate
  },
  created () {
    this.getUserLog()
  }
}
</script>

<style lang="scss" scoped>
.log-wrapper {
  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(29, 36, 60, 1);
    line-height: 30px;
    margin-bottom: 10px;
  }
  .log-box {
    width: 268px;
    height: 606px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 8px 0px rgba(6, 22, 53, 0.06);
    padding: 24px 0 0 24px;
    box-sizing: border-box;
    .log-item {
      margin-bottom: 32px;
      .first-line {
        display: flex;
        align-items: center;
        margin-bottom: 2px;
        i {
          color: #003d92;
          margin-right: 8px;
          font-size: 14px;
        }
        .city-name {
          margin-right: 6px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(29, 36, 60, 1);
          line-height: 24px;
        }
        .ip {
          font-size: 13px;
          font-weight: 400;
          color: rgba(112, 120, 140, 1);
          line-height: 24px;
        }
      }
      .time {
        padding-left: 22px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(29, 36, 60, 1);
        line-height: 24px;
      }
    }
  }
}
</style>
